import { useState } from 'react'
import { CLIKART_ALL_CATEGORIES_OPTION } from '@/lib/clikart/clikart-category-filter'
import type { ClikArtPlacedFilter } from '@/lib/clikart/clikart-placed-filter'
import { CLIKART_SORT_DEFAULT, type ClikArtSortValue } from '@/lib/clikart/clikart-sort'

/**
 * ClikArt's category selection and filename search query, lifted up into `RightPanel` (rather
 * than owned by `ClikArtPanel` itself) so they survive `ClikArtPanel` unmounting when the right
 * panel closes or switches to a different rail icon — `RightPanel` itself stays mounted for the
 * whole session, so this is what makes WMPCM-10942 AC-9/AC-10 ("previously selected category and
 * filters are restored" on reopen) true within a session. Keywords, Placed and Sort are lifted
 * here too, so the whole Filters section survives an unmount.
 *
 * Returns the controlled props for `ClikArtPanel`.
 */
export function useClikArtFilters() {
  const [category, setCategory] = useState(CLIKART_ALL_CATEGORIES_OPTION)
  const [searchQuery, setSearchQuery] = useState('')
  const [keywords, setKeywords] = useState<string[]>([])
  const [placed, setPlaced] = useState<ClikArtPlacedFilter>('any')
  const [sort, setSort] = useState<ClikArtSortValue>(CLIKART_SORT_DEFAULT)

  return {
    category,
    onCategoryChange: setCategory,
    searchQuery,
    onSearchQueryChange: setSearchQuery,
    keywords,
    onKeywordsChange: setKeywords,
    placed,
    onPlacedChange: setPlaced,
    sort,
    onSortChange: setSort,
  }
}
